import React from "react";
import "./how-it-works.css";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";

const features = [
  {
    name: "Sign Up",
    description:
      "Register a free account, and take your first step to securing your asset.",
    icon: Check,
  },
  {
    name: "Secure Your Asset",
    description: "Connect your Wallet to the vault, to secure your asset.",
    icon: Check,
  },
  {
    name: "Loans & Mortgages",
    description:
      "QUANTUM FINANCIAL SYSTEM guide you to make the right loan and mortgage choices that are absolutely suiting to you.",
    icon: Check,
  },
];
const HowItWorks = () => {
  const navigate = useNavigate();
  return (
    <div className="about-section" id="hiw">
      <div className="about-wrapper">
        <div className="why-choose-us-text-container about-text">
          <div className="header" data-aos="fade-up">
            <span className="header-line"></span>
            <h2>how it works</h2>
          </div>
          <h1 data-aos="fade-up">
            learn how Quantum Assests Global Ledger works
          </h1>
          <p data-aos="fade-up">
            With the activation of the QFS, the Alliance will have completely
            destroyed the Rothschild Central Banking system that has been
            designed by Meyer Amschel Rothschild (1744 – 1812) to control the
            world economy and put the world population into debt slavery. Truth
            is, the QFS has been running in parallel with the Central Banking
            System for some time and has countered many hacking attempts by the
            Cabal to steal funds. In the process, many banksters have been
            caught red handed and arrested. This powerful quantum computer
            system could assign a digital number to every fiat dollar/euro/Yen
            sitting in every bank account all over the world and consequently
            monitor in real-time money streams; knowing exactly where particular
            monies went when it was transferred, who sent it by their login
            info, and which account received the money. Imagine the frustration
            of a banker who has just stolen some money and this illegally
            transferred to another account and subsequently being arrested in
            real time for theft. These poor bankster devils, have been defeated.
            They are taking their last gasp of air before the weight of their
            ‘death plans’ comes crashing down on their pathetic,
            baby-blood-sucking, bodies.
          </p>
          <dl className="mt-10 max-w-xl space-y-8 text-base/7 text-gray-600 lg:max-w-none">
            {features.map((feature) => (
              <div
                key={feature.name}
                data-aos="fade-up"
                className="relative pl-9"
              >
                <dt className="inline font-semibold text-gray-900">
                  <div>
                    <feature.icon
                      height={24}
                      width={24}
                      aria-hidden="true"
                      className="absolute top-1 left-1 size-5 text-indigo-600"
                    />
                  </div>

                  {feature.name}
                </dt>{" "}
                <dd>{feature.description}</dd>
              </div>
            ))}
          </dl>
          <button
            className="launch-btn launch"
            data-aos="fade-up"
            onClick={() => {
              navigate("/about");
            }}
          >
            <svg
              height="24"
              width="24"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                fill="currentColor"
              ></path>
            </svg>
            <span>learn more</span>
          </button>
        </div>
        <div className="about-img-container">
          <img
            src="/xrp-banner.jpeg"
            width={2432}
            height={1442}
            alt=""
            data-aos="fade-up"
            className="about-img"
          />
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
